import { render, staticRenderFns } from "./CreateFundraiserTypeModal.vue?vue&type=template&id=5f6d0c16&scoped=true&"
import script from "./CreateFundraiserTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateFundraiserTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateFundraiserTypeModal.vue?vue&type=style&index=0&id=5f6d0c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d0c16",
  null
  
)

export default component.exports